/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module WelcomeModule
 */

import {
    Component,
    Input,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';

import { IEmailConfiguration } from 'generated-types';

import * as l10n from './welcome-email-anonymous-server-settings.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *
 *     Component for Anonymous SMTP Server configuration.
 *     Used in Welcome Modal -> Email panel.
 *
 * @author Aravindh Nagarajan
 */
@Component({
    selector: 'welcome-email-anonymous-server-settings',
    templateUrl: './welcome-email-anonymous-server-settings.component.html',
})
export class WelcomeEmailAnonymousServerSettingsComponent {
    /**
     * EmailConfig object.
     */
    @Input()
    public emailConfig: IEmailConfiguration;

    /**
     * Get keys from source bundles for template usage
     */
    public readonly l10nKeys = l10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
